import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parse } from 'query-string';
import {
	CommunityPanelContainer, loadCommunities, Application, LoadingIndicator, Redirect, connectedComponent
} from 'gwx-voyager-components';
import { loadProfile } from '../Profile/profile.actions';
import { profileEmails, parseAttributes, profileName } from '../Profile/ProfileUtils';

/**
 * Containing component that presents the various SendingFacility components
 * and their respective subroutes.
 */
class LandingPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFetching: props.isFetching
		 };
	}

	UNSAFE_componentWillMount() {
		this.setState({ isFetching: true });
		this.props.fetchCommunities(this.props.query);
		this.props.fetchProfile(this.props.profileId);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({	isFetching: nextProps.isFetching });
	}

	render() {
		if (this.state.isFetching) {
			return <LoadingIndicator />;
		}

		const attributes = parseAttributes(this.props.profile, this.props.profileId);
		const emailList = profileEmails(attributes);

		if (emailList === 0) {
			return <Redirect to={`/profile/${this.props.profileId}`} />;
		}

		const pageNumber = parseInt(this.props.query.number, 10);

		if (pageNumber === 0 && this.props.communities.length === 1) {
			return <Redirect to={`/${this.props.communities[0].id}/reports`} />;
		}

		if (pageNumber === 0 && this.props.communities.length === 0) {
			return <Redirect to='/claim' />;
		}

		return (
			<Application
				navigation={{
					brand: {
						brandName: 'Cerner Care Notifications', brandIconName: 'id-badge', alternateBrandClass: 'hasExchange', brandClass: 'brand-name', brandUrl: '/'
					},
					navigationRight: [{ type: 'dropdown', display: profileName(attributes, this.props.username), options: [{ href: `/profile/${this.props.profileId}`, display: 'Profile' }, { href: this.props.helpLink, display: 'Help' }, { href: this.props.logoutLink, display: 'Logout' }] }]
				}}
				timeout={{ delay: this.props.timeout }}
			>
				<CommunityPanelContainer communities={this.props.communities} />
			</Application>
		);
	}
}

LandingPage.defaultProps = {
	username: (window.gwx && window.gwx.ui && window.gwx.ui.username) || 'User',
	helpLink: window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls && window.gwx.ui.props.urls.help,
	logoutLink: (window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls && window.gwx.ui.props.urls.logout) || '/logout',
	timeout: window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.timeout,
	profileId: window.gwx && window.gwx.ui && window.gwx.ui.profileId
};

LandingPage.propTypes = {
	communities: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired
	})).isRequired,
	fetchCommunities: PropTypes.func.isRequired,
	fetchProfile: PropTypes.func.isRequired,
	isFetching: PropTypes.bool.isRequired,
	helpLink: PropTypes.string,
	logoutLink: PropTypes.string,
	username: PropTypes.string,
	timeout: PropTypes.string,
	profileId: PropTypes.string,
	profile: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => {
	const {
		entities: { communities, profile }
	} = state;

	return {
		query: { size: '256', number: '0', ...parse(props.location.search) },
		communities: communities.ids
			.map((id) => communities.results[id]),
		isFetching: communities.isFetching || profile.isFetching,
		component: 'communities',
		profile
	};
};

const mapDispatchToProps = (dispatch) => ({
	/**
	 * Makes a fetch request for the list of sending facilities.
	 */
	fetchCommunities: (query) => dispatch(loadCommunities(query)),

	/**
	 * Makes a fetch request for the profile.
	 * @param {*} id profile id
	 * @returns The profile object
	 */
	fetchProfile: (id) => dispatch(loadProfile(id))
});

export default connectedComponent(LandingPage, mapStateToProps, mapDispatchToProps);
